'use client';

import { signIn } from 'next-auth/react';
import { useEffect } from 'react';

const LOGIN_LOCK_KEY = 'keycloak-login-started';
const LOGIN_LOCK_DURATION_MS = 30_000;

export default function LoginPage() {
  useEffect(() => {
    const now = Date.now();
    const previousAttempt = Number(
      sessionStorage.getItem(LOGIN_LOCK_KEY) ?? '0',
    );

    if (previousAttempt && now - previousAttempt < LOGIN_LOCK_DURATION_MS) {
      return;
    }

    sessionStorage.setItem(LOGIN_LOCK_KEY, String(now));

    void signIn('keycloak', {
      callbackUrl: '/',
      redirect: true,
    }).catch((error) => {
      sessionStorage.removeItem(LOGIN_LOCK_KEY);
      console.error('Keycloak sign-in failed:', error);
    });
  }, []);

  return null;
}
